<template>
  <div class="viewDialog">
    <BaseDialog title="结算方式" :isshow="visible" @handleShow="(val) => { visible = val }" width="65%" height="auto">
      <div class="patentList fatherHeight contBox">
        <div class="momey-total" style="font-size: 16px;font-weight: bold;">
          <div class="item">姓名:{{ info.name|| info.patient_name }}</div>
          <div class="item">日期:{{ info.schedule_date || info.bed_time.substring(0, 11) }}</div>
          <div class="item">病例号:{{ info.case_no }}</div>
          <div class="item item1">身份证号:{{ info.cert_no }}</div>
        </div>
        <div class="box-info">
          <el-descriptions title="" :column="3" border v-if="info.dict_pay_cate == '4040'">
            <el-descriptions-item label="人员姓名" label-class-name="my-label" content-class-name="my-content">{{tableData.psn_name}}</el-descriptions-item>
            <el-descriptions-item label="年龄" label-class-name="my-label" content-class-name="my-content">{{tableData.age}}</el-descriptions-item>
            <el-descriptions-item label="个人负担总金额" label-class-name="my-label" content-class-name="my-content">{{tableData.psn_part_am || tableData.cash_payamt || tableData.brfdje}}</el-descriptions-item>
            <el-descriptions-item label="医疗费总额" label-class-name="my-label" content-class-name="my-content">{{tableData.medfee_sumamt || tableData.zje}}</el-descriptions-item>
            <el-descriptions-item label="全自费金额" label-class-name="my-label" content-class-name="my-content">{{tableData.fulamt_ownpay_amt||tableData.qezf}}</el-descriptions-item>
            <el-descriptions-item label="基金支付总额" label-class-name="my-label" content-class-name="my-content">{{tableData.fund_pay_sumamt}}</el-descriptions-item>
            <el-descriptions-item label="结算时间" label-class-name="my-label" content-class-name="my-content">{{tableData.setl_time || tableData.brjsrq}}</el-descriptions-item>
            <el-descriptions-item label="基金支付类型" label-class-name="my-label" content-class-name="my-content">{{tableData.fund_pay_type}}</el-descriptions-item>
            <el-descriptions-item label="现金支付金额" label-class-name="my-label" content-class-name="my-content">{{tableData.psn_cash_pay || tableData.cash_payamt}}</el-descriptions-item>
            <el-descriptions-item label="符合范围金额" label-class-name="my-label" content-class-name="my-content">{{tableData.inscp_scp_amt}}</el-descriptions-item>
            <el-descriptions-item label="本次可支付限额金额" label-class-name="my-label" content-class-name="my-content">{{tableData.crt_payb_lmt_amt}}</el-descriptions-item>
            <el-descriptions-item label="违规类型" label-class-name="my-label" content-class-name="my-content">{{tableData.vola_type}}</el-descriptions-item>
            <el-descriptions-item label="基本医疗保险统筹基金支出" label-class-name="my-label" content-class-name="my-content">{{tableData.hifp_pay}}</el-descriptions-item>
            <el-descriptions-item label="基本医疗保险统筹基金支付比例" label-class-name="my-label" content-class-name="my-content">{{tableData.pool_prop_selfpay}}</el-descriptions-item>
            <el-descriptions-item label="险种类型" label-class-name="my-label" content-class-name="my-content">{{tableData.insutype}}</el-descriptions-item>
            <el-descriptions-item label="违规说明" label-class-name="my-label" content-class-name="my-content">{{tableData.vola_dscr}}</el-descriptions-item>
        </el-descriptions>
          <el-collapse v-model="activeNames" @change="handleChange" v-if="info.dict_pay_cate == '4040'">
            <el-collapse-item title="更多信息" name="1">
              <div>
                <el-descriptions title="" :column="3" border>
                  <el-descriptions-item label="就诊ID" label-class-name="my-label" content-class-name="my-content">{{tableData.mdtrt_id}}</el-descriptions-item>
                  <el-descriptions-item label="人员编号" label-class-name="my-label" content-class-name="my-content">{{tableData.psn_no}}</el-descriptions-item>
                  <el-descriptions-item label="证件类型" label-class-name="my-label" content-class-name="my-content">{{tableData.psn_cert_type}}</el-descriptions-item>
                  <el-descriptions-item label="证件号码" label-class-name="my-label" content-class-name="my-content">{{tableData.certno}}</el-descriptions-item>
                  <el-descriptions-item label="性别" label-class-name="my-label" content-class-name="my-content">{{tableData.gend}}</el-descriptions-item>
                  <el-descriptions-item label="出生日期" label-class-name="my-label" content-class-name="my-content">{{tableData.brdy}}</el-descriptions-item>
                  <el-descriptions-item label="基金支付名称" label-class-name="my-label" content-class-name="my-content">{{tableData.fund_pay_type_name}}</el-descriptions-item>
                  <el-descriptions-item label="人员类别" label-class-name="my-label" content-class-name="my-content">{{tableData.psn_type || tableData.tjrylb}}</el-descriptions-item>
                  <el-descriptions-item label="就诊凭证类型" label-class-name="my-label" content-class-name="my-content">{{tableData.mdtrt_cert_type}}</el-descriptions-item>
                  <el-descriptions-item label="医疗类别" label-class-name="my-label" content-class-name="my-content">{{tableData.med_type}}</el-descriptions-item>
                  <el-descriptions-item label="超限价自费费用" label-class-name="my-label" content-class-name="my-content">{{tableData.overlmt_selfpay}}</el-descriptions-item>
                  <el-descriptions-item label="先行自付金额" label-class-name="my-label" content-class-name="my-content">{{tableData.preselfpay_amt || tableData.sxzfje}}</el-descriptions-item>
                  <el-descriptions-item label="符合政策范围金额" label-class-name="my-label" content-class-name="my-content">{{tableData.inscp_scp_amt || tableData.bcnrtcfw}}</el-descriptions-item>
                  <el-descriptions-item label="实际支付起付线" label-class-name="my-label" content-class-name="my-content">{{tableData.act_pay_dedc || tableData.bcqfx}}</el-descriptions-item>
                  <el-descriptions-item label="结算过程信息" label-class-name="my-label" content-class-name="my-content">{{tableData.setl_proc_info}}</el-descriptions-item>
                  <el-descriptions-item label="医疗机构目录编码" label-class-name="my-label" content-class-name="my-content">{{tableData.medins_list_codg}}</el-descriptions-item>
                  <el-descriptions-item label="医疗机构目录名称" label-class-name="my-label" content-class-name="my-content">{{tableData.medins_list_name}}</el-descriptions-item>
                  
                  <el-descriptions-item label="医疗目录编码" label-class-name="my-label" content-class-name="my-content">{{tableData.med_list_codg}}</el-descriptions-item>
                  <el-descriptions-item label="居民大病保险资金支出" label-class-name="my-label" content-class-name="my-content">{{tableData.hifmi_pay || tableData.dbbzje}}</el-descriptions-item>
                  <el-descriptions-item label="医疗救助基金支出" label-class-name="my-label" content-class-name="my-content">{{tableData.maf_pay || tableData.ylbzje}}</el-descriptions-item>
                  <el-descriptions-item label="其他基金支出" label-class-name="my-label" content-class-name="my-content">{{tableData.oth_pay}}</el-descriptions-item>
                  <el-descriptions-item label="个人账户支出" label-class-name="my-label" content-class-name="my-content">{{tableData.acct_pay || tableData.grzhzf}}</el-descriptions-item>
                  <el-descriptions-item label="医院负担金额" label-class-name="my-label" content-class-name="my-content">{{tableData.hosp_part_amt || tableData.yyfdje}}</el-descriptions-item>
                  <el-descriptions-item label="基金支付金额" label-class-name="my-label" content-class-name="my-content">{{tableData.fund_payamt}}</el-descriptions-item>
                  <el-descriptions-item label="个人账户支出后余额" label-class-name="my-label" content-class-name="my-content">{{tableData.balc || tableData.zhye}}</el-descriptions-item>
                  <el-descriptions-item label="账户共济支付金额" label-class-name="my-label" content-class-name="my-content">{{tableData.acct_mulaid_pay}}</el-descriptions-item>
                  <el-descriptions-item label="清算经办机构" label-class-name="my-label" content-class-name="my-content">{{tableData.clr_optins}}</el-descriptions-item>
                  <el-descriptions-item label="清算方式" label-class-name="my-label" content-class-name="my-content">{{tableData.clr_way}}</el-descriptions-item>
                  <el-descriptions-item label="清算类别" label-class-name="my-label" content-class-name="my-content">{{tableData.clr_type}}</el-descriptions-item>
                  <el-descriptions-item label="企业补充医疗保险基金支出" label-class-name="my-label" content-class-name="my-content">{{tableData.hifes_pay}}</el-descriptions-item>
                  <el-descriptions-item label="公务员医疗补助资金支出" label-class-name="my-label" content-class-name="my-content">{{tableData.cvlserv_pay}}</el-descriptions-item>
                  <el-descriptions-item label="职工大额医疗费用补助基金支出" label-class-name="my-label" content-class-name="my-content">{{tableData.hifob_pay}}</el-descriptions-item>
                  <el-descriptions-item label="医药机构结算ID" label-class-name="my-label" content-class-name="my-content">{{tableData.medins_setl_id}}</el-descriptions-item>
                  <el-descriptions-item label="公务员标志" label-class-name="my-label" content-class-name="my-content">{{tableData.cvlserv_flag}}</el-descriptions-item>
                  <el-descriptions-item label="备注" label-class-name="my-label" content-class-name="my-content">{{tableData.memo}}</el-descriptions-item>
                </el-descriptions>
              </div>
            </el-collapse-item>
          </el-collapse>
          <table class="info-table" cellspacing="0" v-if="info.dict_pay_cate == '1001'">
            <!--表格 4-31门诊预结算输出节点1（结算setlinfo）开始-->
            <tr>
              <td class="color-blue border-right">费用总金额</td>
              <td class="border-right">{{ tableData.medfee_sumamt  || tableData.zje}}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </table>
          <div class="title-bar" style="margin-bottom: 10px;">支付方式</div>
          <el-table v-loading="dataListLoading" :data="pay_data" style="width: 100%">
            <el-table-column prop="name" label="支付方式" width="180">
            </el-table-column>
            <el-table-column prop="name" label="支付金额" width="180">
              <template #default="scope">
                <el-input clearable v-model="scope.row.amount" placeholder="" type="number" min="0.00"
                  step="0.01"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="bank_name" label="开户银行">
              <template #default="scope">
                <el-input clearable v-model="scope.row.bank_name" placeholder=""></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="account_no" label="开户账号">
              <template #default="scope">
                <el-input clearable v-model="scope.row.account_no" placeholder=""></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="pay_voucher" label="支付凭证">
              <template #default="scope">
                <el-input clearable v-model="scope.row.pay_voucher" placeholder=""></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="real_amount" label="实收金额">
              <template #default="scope">
                <el-input clearable v-model="scope.row.real_amount" placeholder=""></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="color-cancel" type="primary" @click="caseClick">
            取消
          </el-button>
          <el-button @click="savePatient" :disabled="saveType == 1 ? true : false" :loading="saveLoad"
            class="color-determine" type="primary">
            确定
          </el-button>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>
<script setup name="tuiFei">
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount, defineEmits
  } from 'vue'
  import service from '@/utils/request'
  import { gitDictList } from '@/utils/tool'
  import { ElMessageBox, ElMessage } from 'element-plus'
  const emit = defineEmits(["refreshDataList"])
  import BaseDialog from '@/components/Dialog/index.vue'
  const visible = ref(false)
  const saveLoad = ref(false)
  const saveType = ref(0)
  function caseClick() {
    visible.value = false
    console.log(pay_data.value)
    tableData.value = {}
    pay_data.value = [
      { name: '现金', pay_type: 'amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
      { name: '微信', pay_type: 'wechat_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
      { name: '支付宝', pay_type: 'ali_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
      { name: '银行卡', pay_type: 'bank_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
      { name: '医保卡', pay_type: 'medi_card_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
      { name: '电子医保码', pay_type: 'medi_code_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    ]
    emit('refreshDataList')
  }
  async function savePatient() {
    let total = pay_data.value.reduce((pre, cur) => {
      return Number(pre) + Number(cur.amount)
    }, 0)
    // tableData.psn_cash_pay || tableData.cash_payamt
    if (info.value.dict_pay_cate == '1001') {
      // zje
      // if (total.toFixed(2) != Number(tableData.value.medfee_sumamt).toFixed(2) ) {
      //   validateFun()
      // } else {
      //   save()
      // }
      if (total.toFixed(2)==null || total.toFixed(2) == Number(tableData.value.medfee_sumamt).toFixed(2) || total.toFixed(2)==0.00 || total.toFixed(2)=='' || total.toFixed(2) == Number(tableData.value.zje).toFixed(2) ) {
        save()
      } else {
        validateFun()
      }
    } else {
      if(total.toFixed(2)==null ||total.toFixed(2)==0.00 || total.toFixed(2)==''||total.toFixed(2) == Number(tableData.value.psn_cash_pay).toFixed(2)||total.toFixed(2) == Number(tableData.value.cash_payamt).toFixed(2)){
        save()
      }
      else{
        validateFun()
      }
      // if (total.toFixed(2) != Number(tableData.value.psn_cash_pay).toFixed(2)||total.toFixed(2) != Number(tableData.value.cash_payamt).toFixed(2)) {
      //   validateFun()
      // } else {
      //   save()
      // }
    }
  }

  function validateFun() {
    ElMessage.error('结算金额与费用不符!')
    // ElMessageBox.confirm(
    //   '是否确认提交?',
    //   'Warning',
    //   {
    //     confirmButtonText: '是',
    //     cancelButtonText: '取消',
    //     type: 'warning',
    //   }
    // )
    //   .then(() => {
    //     save()
    //   })
  }
  async function save() {
    // saveLoad.value = true
    let data = {
      ...info.value,
      pay_data: pay_data.value
    }
    saveLoad.value = true
    let res = await service.post(
      '/api/medical/sub_settle_accounts',
      data
    )
    
    if (res.code === 0) {
      saveLoad.value = false
      ElMessage.success(res.msg)
      visible.value = false
      saveType.value = 1
      pay_data.value = [
        { name: '现金', pay_type: 'amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
        { name: '微信', pay_type: 'wechat_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
        { name: '支付宝', pay_type: 'ali_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
        { name: '银行卡', pay_type: 'bank_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
        { name: '医保卡', pay_type: 'medi_card_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
        { name: '电子医保码', pay_type: 'medi_code_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
      ]
      console.log(pay_data.value, ' ==pay_data.value ')
      tableData.value = {}
      emit('refreshDataList')
      saveLoad.value = false
    }else{
      saveLoad.value = false
    }
  }
  const info = ref({})
  const pay_data = ref([
    { name: '现金', pay_type: 'amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '微信', pay_type: 'wechat_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '支付宝', pay_type: 'ali_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '银行卡', pay_type: 'bank_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '医保卡', pay_type: 'medi_card_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '电子医保码', pay_type: 'medi_code_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
  ])
  const pay_dataAll = ref([
    { name: '现金', pay_type: 'amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '微信', pay_type: 'wechat_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '支付宝', pay_type: 'ali_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '银行卡', pay_type: 'bank_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '医保卡', pay_type: 'medi_card_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
    { name: '电子医保码', pay_type: 'medi_code_amount', amount: '', bank_name: '', account_no: '', pay_voucher: '', real_amount: '' },
  ])
  const dataListLoading = ref(false)
  const tableData = ref({})

  //获取医保接口预结算数据
  const getDataList = async (item) => {
    dataListLoading.value = true
    let res = await service.post(
      '/api/medical/pre_settle_accounts',
      item
    )
    dataListLoading.value = false
    if (res.code === 0) {
      tableData.value = res.data
      // statistic.value = '总金额:123  待结算金额:123 已退费金额:123 病人待结算金额:123'
    }
  }

  defineExpose({
    visible,
    info,
    getDataList,
    saveType,
    validateFun,
    save
  })
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
</style>
<style scoped lang="scss">
  ::v-deep .my-label {
    background-color: rgba(49, 102, 174, 0.1) !important;
    border: 1px solid #e4e9f8 !important;
    color: #3166ae !important;
    font-weight: 400 !important;
  }

  ::v-deep .my-content {
    background: #FDE2E2;
  }

  ::v-deep .el-collapse-item__header {
    border: none;
    border-left: 5px solid #3166ae;
    padding-left: 10px;
    height: 30px;
    /* padding: 15px; */
    margin: 10px 0 10px 0px;
  }

  .demo-form-inline {
    margin-top: 0;
    //flex: 1;
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-row-gap: 10px;
    //grid-template-rows: repeat(4, 40px);
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .search-top .w-208 {
    width: 208px;
  }

  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .patientList {
    margin-top: 4px;
    height: calc(100% - 45px);
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  .table {
    margin-top: 10px;
    height: calc(100% - 82px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  }

  .searchBut {
    width: 100%;
    //margin-left: 20px;
    //margin-right: 29px;
    justify-self: right;
    display: flex;
    justify-content: end;
    margin-right: 28px;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .momey-total {
    display: flex;
    margin: 10px;
    line-height: 30px;

    .item {
      margin-right: 20px;
      width: 150px;
    }
  }

  .radio-bg {
    background: rgba(49, 102, 174, 0.1);
    padding: 0px 10px;
    border-radius: 4px;
  }

  .info-table {
    width: 100%;
    margin: 10px 0;

    tr {
      height: 40px;
    }

    td {
      padding-left: 20px;
    }

    .color-blue {
      color: #3166ae;
      font-size: 14px;
      width: 230px;
    }

    .border-right {
      /* border-right: 1px solid gray; */
      padding: 12px 8px;
      text-align: left;
    }

  }

  .info-table tr:nth-child(2n+1) {
    background-color: rgba(49, 102, 174, 0.1);
  }

  .item1 {
    width: 250px !important;
  }
</style>